module.exports = __webpack_public_path__ + "static/Vampire-a380a19c49d544629e6dc337a0455b3b.jpg";